import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { OrdersService } from 'dm-src/app/modules/orders/orders.service';

@Component({
    selector: 'app-customer-notes',
    templateUrl: './customer-notes.component.html',
    styleUrls: ['./customer-notes.component.scss'],
})
export class CustomerNotesComponent implements OnInit {
    @Input() public notes: string;
    public isEditMode = false;
    public isSubmitted = false;
    public customerNotesForm: UntypedFormGroup;

    public get fields() {
        return this.customerNotesForm.controls;
    }

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _ordersService: OrdersService
    ) {}

    ngOnInit(): void {
        this.customerNotesForm = this._formBuilder.group({
            notes: [this.notes, Validators.required],
        });
    }

    public updateCustomerNotes() {
        this.isSubmitted = true;

        if (this.customerNotesForm.invalid) {
            return false;
        }

        this._ordersService
            .updateCustomerNotes(this.fields.notes.value)
            .subscribe((response) => {
                if (response.status === 200) {
                    this.notes = this.fields.notes.value;
                    this.isEditMode = false;
                }
            });
    }
}
